import React from 'react';
import { Sparkles } from 'lucide-react';
import { getNewProducts } from '../mock/mock';
import ProductCard from '../components/ProductCard';

const NewProducts = () => {
  const products = getNewProducts();
  return (
    <div>
      <div className="ps-blue-bg text-white">
        <div className="max-w-7xl mx-auto px-6 py-16 text-center">
          <div className="inline-flex items-center gap-2 ps-yellow-bg text-black px-4 py-1.5 rounded-full font-oswald uppercase text-sm tracking-wide mb-4">
            <Sparkles size={16} /> Just Arrived
          </div>
          <h1 className="font-anton text-5xl sm:text-6xl">OUR NEWEST PRODUCTS</h1>
          <p className="text-white/70 mt-4 max-w-xl mx-auto">Fresh drops for your pets and home — including our brand-new Kitchen &amp; Bath and Pet Bath collections.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </div>
  );
};

export default NewProducts;
